import { render } from "./cdrBatchConsumptionDetails.vue?vue&type=template&id=0215b1f9&scoped=true"
import script from "./cdrBatchConsumptionDetails.vue?vue&type=script&lang=js"
export * from "./cdrBatchConsumptionDetails.vue?vue&type=script&lang=js"

import "./cdrBatchConsumptionDetails.vue?vue&type=style&index=0&id=0215b1f9&scoped=true&lang=css"
import "./cdrBatchConsumptionDetails.vue?vue&type=style&index=1&id=0215b1f9&lang=css"
script.render = render
script.__scopeId = "data-v-0215b1f9"

export default script